module.exports = __webpack_public_path__ + "img/maru.1f8142e2.jpg";